import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import shapePng from '../../resources/blog-featured-shape.png'

export const Container = styled.div`
  ${props => props.theme.css.containerWide};
  margin-bottom: 24px;

  h1 {
    ${props => props.theme.css.heading2};
    border-bottom: 1px solid ${props => props.theme.palette.general.grey};
    padding: 15px 0;
  }

  .featured-section {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px;
    background: ${props => props.theme.palette.primary.alpha};
    ${bp('sm')`
      flex-wrap: wrap;

      h4 {
        font: ${font('default', 'light', '18px/1')};
      }

      a {
        margin-top: 10px;
      }
    `}

    &::before {
      content: '';
      display: block;
      width: 10%;
      height: 100%;
      background: url(${shapePng}) no-repeat bottom left;
      position: absolute;
      z-index: -1;
      left: 0;
      bottom: 0;
    }

    h4 {
      font: ${font('default', 'light', '24px/1')};
      margin: 0 20px 0 0;
    }

    a {
      ${props => props.theme.css.facebookButton};
    }
  }
`
